var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('NavigationTo',{attrs:{"path":_vm.path}},[_c('div',{staticClass:"btn _pointer",attrs:{"slot":"content"},slot:"content"},[_vm._v("\n      "+_vm._s(_vm.btnTxt)+"\n    ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }